/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.coaching.tips.rpc.StatusRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getStatusRpc = {
  serviceName: 'com.hubspot.coaching.tips.rpc.StatusRpc',
  rpcName: 'getStatus',
  auth: 'app',
  fingerprint: 'Uw61iNZ0LzPUY7bHKwrk2JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateStatusRpc = {
  serviceName: 'com.hubspot.coaching.tips.rpc.StatusRpc',
  rpcName: 'updateStatus',
  auth: 'app',
  fingerprint: '5XDcDqKQuS60Kt_i59waC5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteStatusRpc = {
  serviceName: 'com.hubspot.coaching.tips.rpc.StatusRpc',
  rpcName: 'deleteStatus',
  auth: 'app',
  fingerprint: 'JJ5N54Qw2yHtoPLL13-mnpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};